var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{attrs:{"data-testid":"afk-remark"}},[_vm._v(_vm._s(_vm.tag)+": "+_vm._s(_vm.remark))])
}
var staticRenderFns = []

export { render, staticRenderFns }